import { Component, Provide, Vue, Watch } from 'vue-property-decorator'
import { appData, notice, words } from './model'
import dayjs from 'dayjs'
import { db } from '@/libs/utils'
import { TableRecord } from '@va/storage'
import { namespace } from 'vuex-class'
import configs from '@/config'
import { PageNames } from '@/router'
import { AppItem, NoticeItem } from '@/model/definitions'
import { UserInfoResDTO } from '@/services/permission'
import cookie from 'js-cookie'
import { KEY_MY_APPS_SORT, KEY_SHOW_EHR_DIALOG, KEY_SSO_APPS_SORT } from '@/model/constants'
import { subscribeSSOAuthLogin } from '@/libs/sso-sync'

const table = db.table('favApps')
const AppModule = namespace('app')

type dbRecord = TableRecord & AppItem

@Component
export default class PortalController extends Vue {
  @AppModule.Mutation('setUserInfo') setUserInfo!: (userInfo: UserInfoResDTO) => void

  @Provide() protected appData: AppItem[] = appData
  @Provide() protected ssoAppData: AppItem[] = []
  @Provide() protected dateStr: string = dayjs().format('YYYY年MM月DD日')
  @Provide() protected favData: TableRecord[] = table.all()
  @Provide() private kw = ''
  @Provide() protected userInfo: UserInfoResDTO | null = null
  @Provide() protected loginFailed = false
  @Provide() protected dragable = false
  @Provide() protected ssoDragable = false
  @Provide() protected myApps: AppItem[] = []
  @Provide() protected token?: string = ''
  @Provide() protected readonly notices: NoticeItem[] = notice
  @Provide() protected showDialog = false
  @Provide() protected closeTip = !!Number(this.$db.getValue(KEY_SHOW_EHR_DIALOG, '0'))
  private unsubscribeSSOAuthLogin: (() => void) | null = null

  @Provide() protected hrApps: AppItem[] = [
    {
      id: 30,
      appName: 'MoKa招聘',
      subName: '招聘人员专用',
      link: 'https://app.mokahr.com/offer-approvals',
      avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/e969/0764/f58f/41d6fdd2-f85f-4670-969e-6f56145add58'
    },
    {
      id: 31,
      appName: '唯寻学堂',
      subName: '唯寻人自己的培训学堂',
      link: 'https://pro.coolcollege.cn/#/index-auth-login-new?source=ding',
      avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/8888/5874/47c3/e7f0dc29-3c74-4785-8888-54218931b84c'
    }
  ]

  @Provide() protected draggableCfg: Record<string, string | number> = {
    animation: 500
  }

  get today(): string {
    const w = ['日', '一', '二', '三', '四', '五', '六']
    return `${this.dateStr}，星期${w[dayjs().day()]}`
  }

  get aWord(): string {
    const index = Math.ceil(Math.random() * words.length - 1)
    return words[index]
  }

  @Watch('closeTip')
  private closeTipWatcher(val: boolean): void {
    const d = val ? '1' : '0'
    this.$db.setValue(KEY_SHOW_EHR_DIALOG, d)
  }

  private get loginUrl(): string {
    return `${window.location.origin}${configs.loginPath}`
  }

  private mounted (): void {
    this.unsubscribeSSOAuthLogin = subscribeSSOAuthLogin(this.loginUrl, this.handleSSOAuthSync)
    this.token = cookie.get(configs.keySSOToken)
    if (this.token) {
      this.init()
    }

    this.getMyApps()
  }

  private beforeDestroy(): void {
    if (this.unsubscribeSSOAuthLogin) {
      this.unsubscribeSSOAuthLogin()
    }
  }

  private handleSSOAuthSync = async (authToken: string): Promise<void> => {
    if (!authToken || this.token === authToken) return

    this.token = authToken
    await this.init()
    this.getMyApps()
  }

  protected doSearch(kw: string): void {
    this.kw = kw
    this.$nextTick(() => {
      this.getMyApps()
    })
  }

  private async init(): Promise<void> {
    const sortedData = (this.$db.getValue(KEY_SSO_APPS_SORT) || []) as { id: number, order: number }[]
    const result = await this.$api.Permission.UserResourcePermissionController.listUserSystemResourcePermission()
    if (result.code === 'success' && result.data) {
      const data = result.data
      this.setUserInfo(data.userInfoResDTO || {})
      this.userInfo = data.userInfoResDTO || null
      if (data.dataList && data.dataList.length) {
        this.ssoAppData = data.dataList
          .filter(d => d.visibleState === 1)
          .map(d => {
            const find = sortedData.find((s: { id: number, order: number }) => s.id === Number(d.resourceId))
            const tmp = {
              id: d.resourceId || 0,
              appName: d.systemName || '未命名',
              avatarUrl: d.logUrl || '',
              link: d.systemUrl || '',
              order: 0
            }
            if (find) {
              tmp.order = find.order
            }
            return tmp
          }).sort((a, b) => a.order - b.order)
      }
      // -
    } else {
      // this.$router.replace({ name: PageNames.UserLogin })
      if (result.code === '7000') {
        this.token = ''
      }
    }
  }

  private getMyApps(): void {
    const sortedData = (this.$db.getValue(KEY_MY_APPS_SORT) || []) as { id: number, order: number }[]
    this.myApps = this.appData.filter(app => {
      // 没被收藏
      // const faved = this.favData.some(fav => fav.appName === app.appName)
      // 如果有kw, 满足kw的
      const matched = this.kw ? app.appName.indexOf(this.kw) > -1 : true
      // 有权限的app (有权限的全能看, 否则只能看见 非techOnly的)
      const teched = this.userInfo ? true : !app.techOnly
      // 配置了env的, 只在对应环境展示; 没配置则所有环境展示
      const envMatched = app.env ? app.env === configs.env : true

      return matched && teched && envMatched
    })
      .map(app => {
        const find = sortedData.find((d: { id: number, order: number }) => d.id === app.id)
        if (find) {
          app.order = find.order
        }
        return app
      })
      .sort((a, b) => (a.order || 0) - (b.order || 0))
  }

  protected async getUserInfo(): Promise<void> {
    // const ret = await this.$api.UserMgmt.getEmploy() as unknown as AnyObject
    // // this.userInfo = await this.$api.UserMgmt.getEmploy()
    // this.userInfo = ret.data
    // if (this.userInfo) {
    //   this.setUserInfo(this.userInfo)

    //   // 有 Weixun_PortalAdmin 这个系统权限的
    // }
  }

  protected appClick(app: AppItem): void {
    if (this.dragable) {
      return
    }
    if (app.link) {
      if (app.link.startsWith('/')) {
        // this.$router.push({ path: app.link })
        window.open(`${location.protocol}//${location.host}${app.link}`)
      } else if (app.link.startsWith('http')) {
        window.open(app.link)
      } else {
        // console.log(`${location.protocol}//${$config.prefix}${app.link}`, 'env')
        window.open(`${location.protocol}//${configs.prefix}.${app.link}`)
      }
    }
  }

  // 收藏功能下线了;
  protected appFav(app: AppItem): void {
    const record = table.find('appName', app.appName)
    if (!record) {
      table.insert(app)
      this.favData = table.all()
    }
  }

  protected onRemove(app: AppItem): void {
    const data = app as dbRecord
    if (data.id) {
      table.remove(data.id)
      this.favData = table.all()
    }
  }

  protected goToLogin(): void {
    this.$router.replace({ name: PageNames.UserLogin })
  }

  protected triggerDrag(): void {
    this.dragable = !this.dragable
  }

  protected triggerSSODrag(): void {
    this.ssoDragable = !this.ssoDragable
  }

  protected dragEnd(): void {
    const newSort = this.myApps.map((d, index: number) => ({
      id: d.id,
      order: index + 1
    }))
    this.$db.setValue(KEY_MY_APPS_SORT, newSort)
  }

  protected ssoDragEnd(): void {
    const newSort = this.ssoAppData.map((d, index: number) => ({
      id: d.id,
      order: index + 1
    }))
    this.$db.setValue(KEY_SSO_APPS_SORT, newSort)
  }

  protected ehrClick(): void {
    const needDialog = this.$db.getValue(KEY_SHOW_EHR_DIALOG, '0')
    console.log(Number(needDialog), 'ss')
    if (Number(needDialog) === 0) {
      this.showDialog = true
    } else {
      window.open('https://core.mokahr.com/')
    }
  }
}
